module.exports = __webpack_public_path__ + "img/banner_helper.2ffdfcd8.png";